import { render, staticRenderFns } from "./NewFundDestinations.vue?vue&type=template&id=c651c09c&scoped=true"
import script from "./NewFundDestinations.vue?vue&type=script&lang=js"
export * from "./NewFundDestinations.vue?vue&type=script&lang=js"
import style0 from "./NewFundDestinations.vue?vue&type=style&index=0&id=c651c09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c651c09c",
  null
  
)

export default component.exports